<template>
<!-- 
  Author: lan.h
  Date: 2021-10-21
  content: 历届发布
-->
  <div class="vb100 release">
    <div class="p_head">
      <div class="p_title">
        <p>VB100</p>
        <h1>{{year_index.name}}</h1>
      </div>
      <div class="p_links">
        <div class="links-item js-lower-anchor" v-for="item in year_list"  @click="yearChange(item)">
          <p class="links-name" :class="item.id == year_index.id ? 'y_active' : ''">{{item.name}}</p>
          <i></i>
        </div>
      </div>
    </div>
    <div class="banner_name">
      <span v-for="item, index in year_index.banner" :key="index" :class="banner_index.id == item.id ? 'active' : ''" @click="bannerChane(item)">{{item.name}}</span>
    </div>
    <div class="p_image" :key="banner_index.logo_path">
      <div class="p_image_inner">
        <img id="p_image" class="animate__animated" :src="banner_index.logo_path | logo" @click="bannerTo()">
      </div>
    </div>
    <!-- 历届榜单 -->
    <div class="his-content" id="list-table">
      <div class="list-content">
        <div class="info">
          <div class="list-title">历届榜单</div>
          <div class="list-png">
            <img src="~/img/main/list.png" />
          </div>
        </div>
        <div class="table-title">
          <div>
            <img src="~/img/main/list-left.png" />
            <div>
              <h1>{{detail.title}}</h1>
              <p>{{year_index.name}}</p>
            </div>
            <img src="~/img/main/list-right.png" />
          </div>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <div class="list-wap">
      <div class="list-table" ref="table">
        <table :key="key_index" :style="{width: columns.length + 1 +'rem'}">
          <tr class="tr-th">
            <th v-for="item, index in columns" :key="index">{{item.name}}</th>
          </tr>
          <tbody>
            <tr class="tr-td" v-for="item, index in tableData" :key="index">
              <template v-for="tds,tk in item">
                <td v-if="n_key == tk">
                  <div class="table-td">
                    <!-- 动脉橙 -->
                    <p v-if="detail.jump == '1'" class="over-p2">
                      <a v-if="getResult(item, '1')" class="main_page" :href="'https://vbdata.cn/' + getResult(item, '1')" target="_blank">{{tds}}</a>
                      <span v-else>{{tds}}</span>
                    </p>
                    <!-- 官网 -->
                    <p v-else-if="detail.jump == '2'" class="over-p2">
                      <a v-if="getResult(item, '2')" class="main_page" :href="getResult(item, '2')" target="_blank">{{tds}}</a>
                      <span v-else>{{tds}}</span>
                    </p>
                    <!-- 不跳转 -->
                    <p v-else class="over-p2">{{tds}}</p>
                  </div>
                </td>
                <td v-else>
                  <div class="table-td">
                    <p class="over-p2">{{tds}}</p>
                  </div>
                </td>
              </template>
            </tr>
          </tbody>
        </table>
        <div class="remark" v-html="detail.remarks"></div>
      </div>
    </div>
    <!-- 锚点 -->
    <div class="condition" v-if="is_condition">
      <div class="condition-item">
        <el-dropdown placement="top" @command="yearChange" trigger="click">
          <span class="el-dropdown-link">
            {{year_index.name}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="item" v-for="item in  year_list" :key="item.id">{{item.name}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="condition-item">
        <el-dropdown placement="top" @command="openYear" trigger="click">
          <span class="el-dropdown-link">
            {{detail.title}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="over-p1" :command="item" v-for="item in  anchor_list" :key="item.id">
                {{item.title}}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { getVBBannerList, getVbTopListByYear } from '@/service/main.js'
import { list_mixin } from 'mjs/list_mixins'
export default{
  mixins: [list_mixin],
  data() {
    return {
      year_list: [], //年份数组
      year_list_copy: [], //年份数组 原始
      year_index: {}, //当前年
      banner_index: {}, //当前吧banner
      tableData: [], //表格数据
      columns: [], //表头数组
      loading: false, 
      anchor_list: [], //锚点数组

      detail: '',
      key_index: '',
      is_condition: true
    }
  },
  computed: {
    list_meta() {
      return this.$store.state.list_meta
    },
    awards_id() {
      let id = this.$store.state.list_meta.awards_meta.find(item => item.route == this.$route.name).id
      return id
    }
  },
  mounted() {
    let _this = this
    this.$nextTick(() => {
      window.onscroll = () => {
        _this.listenerScroll('anchor', 20)
      }
      window.onresize = () => {
        _this.listenerScroll('anchor', 20)
      }
    })
  },
  beforeDestroy(){
    window.onscroll = null
    window.onresize = null
  },
  created() {
    this.getVBBannerList()
  },
  methods: {
    //banner跳转
    bannerTo() {
      if(this.banner_index.url){
         window.open(this.banner_index.url, '_blank')
      }
    },
    // 年份切换
    yearChange(item) {
      // let arr = [...this.year_list_copy]
      // let index = arr.findIndex(i => i.id == item.id)
      // arr.splice(index, 1)
      // this.year_list = arr

      this.year_index = item
      this.banner_index =  item.banner.length > 0 ?  item.banner[0] : {}
      this.getVbTopListByYear(item.id)
    },
    //banner切换
    bannerChane(item) {
      this.banner_index = item
    },
    //获取年数据
    async getVBBannerList() {
      let res = await getVBBannerList({}, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        this.$set(this.$data, 'year_list', res.res)
        this.year_list_copy =  JSON.parse(JSON.stringify(res.res))
        if(res.res.length > 0){
          this.year_index = res.res[0]
          // this.year_list.splice(0, 1)
          this.banner_index = this.year_index.banner.length > 0 ? this.year_index.banner[0] : {}
          this.getVbTopListByYear(this.year_index.id)
        }
      } else {
        this.$Message.error(res.msg)
      }
    },
    //获取表格数据
    async getVbTopListByYear(awards_year_id) {
      this.loading = true
      let res = await getVbTopListByYear({
        awards_year_id: awards_year_id,
        type: 1
      }, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        this.$set(this.$data, 'anchor_list', res.res)
        if(res.res.length > 0){
          let deal_temp = this.dealList(res.res[0].content)
          this.key_index = res.res[0].id
          this.$set(this.$data, 'tableData', deal_temp.arr)
          this.$set(this.$data, 'columns', deal_temp.col_list)
          this.$set(this.$data, 'detail', res.res[0])
          this.matching_results = res.res[0].matching_results ? JSON.parse(res.res[0].matching_results) : []
        }
        this.loading = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    //点击榜单
    openYear(item) {
      $("html,body").animate({ scrollTop: $('#list-table').offset().top }, 500)
      this.key_index = item.id
      this.detail = item
      let deal_temp = this.dealList(item.content)
      this.$set(this.$data, 'tableData', deal_temp.arr)
      this.$set(this.$data, 'columns', deal_temp.col_list)
      this.$set(this.$data, 'detail', item)
      this.matching_results = item.matching_results ? JSON.parse(item.matching_results) : []
    },
    listenerScroll() {
      let top = document.documentElement.scrollTop || document.body.scrollTop  //滚动条的值
      let vh = document.documentElement.clientHeight
      let footer = $('.footer').offset().top
      if(top >= footer - vh ){
        this.is_condition = false
      }else{
        this.is_condition = true
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~mcss/main/list.stylus';
.y_active
  color #D9BB9E
.release
  .p_head 
    .p_links
      display flex
      flex-wrap wrap
      .links-item
        width 1.6rem
.banner_name
  width calc(100% - 1.2rem)
  margin-top .6rem
  margin-left auto
  margin-right auto
  span 
    margin-right .26rem
    font-size .2rem
    font-weight bold
    color #E9E9EB
    line-height .4rem
    height .4rem
    margin-bottom .15rem
    display inline-block
  span:last-child 
    margin-right 0
  .active
    color #D9BB9E
    border .02rem solid #D9BB9E
    border-radius .2rem
    padding 0 .12rem
.p_image
  transition all .5s
.condition
  width 100%
  height .95rem
  background #1F2330
  box-shadow 0px 2px 10px 0px rgba(14, 15, 20, 0.1)
  position fixed
  bottom 0
  left 0
  display flex
  >div 
    display flex 
    justify-content center
    align-items center
  .condition-item:nth-child(1)
    width 33%
    position relative 
    &::after
      position absolute
      right 0
      top 20%
      content ''
      width .02rem
      height 60%
      background #3D3D3D
  .condition-item:nth-child(2)
    width 66%
</style>